module.exports = __webpack_public_path__ + "img/ciabatta_haev.115103dd.jpg";